import _ from 'lodash';
import { errorKey } from '../utils'

export const stepValidation = (step, selected_type, current_order) => {
  let options = selected_type.construction_type_options;
  let errors = [];

  const isCustomSize = current_order.size.selected == 'CUSTOM_SIZE';
  const isFactoryStandard = !isCustomSize;

  switch(step * 1) {
    case 1:
      if (!current_order.construction.items.length) {
        errors.push(buildError('ConstructionType', 'Не выбран тип конструкции.'))
      }
      break;

    case 2:
      if (isCustomSize) {
        if (!_.get(current_order.size, 'items[0].value') || !_.get(current_order.size, 'items[1].value')) {
          errors.push(buildError('Size', 'Не указаны размеры'))
        }
        if (selected_type.size_limits) {
          let
            heightInputValue = _.get(current_order.size, 'inputValues[0]'),
            widthInputValue = _.get(current_order.size, 'inputValues[1]'),
            minHeight = selected_type.size_limits.min_height,
            minWidth = selected_type.size_limits.min_width;

          if (!heightInputValue || heightInputValue < minHeight) {
            errors.push(buildError('SizeHeight', 'Высота должна быть не менее ' + minHeight + 'мм'));
          }
          if (!widthInputValue || widthInputValue < minWidth) {
            errors.push(buildError('SizeWidth', 'Ширина должна быть не менее ' + minWidth + 'мм'));
          }
        }
      } else if ((current_order.size.selected == 'SIZE' && !current_order.size.items.length) || !current_order.size.selected.length) {
        errors.push(buildError('Size', 'Не выбран размеры.'));
      }

      if (!current_order['open'].item) {
        errors.push(buildError('Open', 'Не выбрана сторона открывания.'));
      }
      break;

    case 3:
      if (isFactoryStandard) {
        if (checkExactField('OutsideColor', current_order, options)) {
          errors.push(buildError('OutsideColor', 'Не выбран цвет внешней отделки.'));
        }
        if (checkExactField('InsidePanel', current_order, options)) {
          errors.push(buildError('InsidePanel', 'Не выбрана внутренняя отделки.'))
        }
        if (checkExactField('InsideColor', current_order, options)) {
          errors.push(buildError('InsideColor', 'Не выбран цвет внутренней отделки.'))
        }
        if (checkExactField('ForgedFinish', current_order, options)) {
          errors.push(buildError('ForgedFinish', 'Не выбрана кованная отделка.'))
        }
      }
      break;

    case 4:
      if (isFactoryStandard) {
        if (checkExactField('LockCommon', current_order, options)) {
          errors.push(buildError('LockCommon', 'Не выбран основной замок.'))
        }
        if (checkExactField('LockPadCommon', current_order, options)) {
          errors.push(buildError('LockPadCommon', 'Не выбрана накладка на основной замок.'))
        }
        if (checkExactField('LockAdditional', current_order, options)) {
          errors.push(buildError('LockAdditional', 'Не выбран дополнительный замок.'))
        }
        if (checkExactField('LockPadAdditional', current_order, options)) {
          errors.push(buildError('LockPadAdditional', 'Не выбрана накладка на дополнительный замок.'))
        }
        if (checkExactField('DoorKnob', current_order, options)) {
          errors.push(buildError('DoorKnob', 'Не выбрана ручка.'))
        }
        if (checkExactField('Latch', current_order, options)) {
          errors.push(buildError('Latch', 'Не выбрана задвижка.'))
        }
      }
      break;
  }

  return errors;
};

const buildError = (klass, errorText) => ({[errorKey(klass)]: errorText});

const keyForMandatory = (key) => {
  return ['mandatory', key].join('_');
};

const checkExactField = (field, order, options) => {
  if (!options) { return false; }
  return options[field] && !order[field];
};



// WEBPACK FOOTER //
// ./app/javascript/app/lib/step_validations.jsx